import { useAppStateStore } from '@client/stores/AppStateStore';

export function useIsOffline() {
    const appStateStore = useAppStateStore();

    return !appStateStore.isOnline;
}
